var _excluded = ["direction"],
  _excluded2 = ["activePage"],
  _excluded3 = ["activePage"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import PageLink from "../PageLink/index.js";
import CaretIcon from "../CaretIcon/index.js";
import { ARROW_NEXT, ARROW_PREV } from "../../utils/index.js";
import styles from "./styles.css";
var DirectionalPageLink = function DirectionalPageLink(_ref) {
  var direction = _ref.direction,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", {
    className: styles.arrow
  }, /*#__PURE__*/React.createElement(PageLink, _extends({
    linkText: /*#__PURE__*/React.createElement(CaretIcon, {
      direction: direction
    })
  }, props)));
};
process.env.NODE_ENV !== "production" ? DirectionalPageLink.propTypes = {
  direction: PropTypes.string.isRequired
} : void 0;
export var NextPageLink = function NextPageLink(_ref2) {
  var activePage = _ref2.activePage,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(DirectionalPageLink, _extends({
    direction: "right",
    "data-link-type": ARROW_NEXT,
    page: activePage + 1,
    activePage: activePage,
    "aria-label": "Go to next page"
  }, props));
};
process.env.NODE_ENV !== "production" ? NextPageLink.propTypes = {
  activePage: PropTypes.number.isRequired
} : void 0;
export var PreviousPageLink = function PreviousPageLink(_ref3) {
  var activePage = _ref3.activePage,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(DirectionalPageLink, _extends({
    direction: "left",
    "data-link-type": ARROW_PREV,
    page: activePage - 1,
    activePage: activePage,
    "aria-label": "Go to previous page"
  }, props));
};
process.env.NODE_ENV !== "production" ? PreviousPageLink.propTypes = {
  activePage: PropTypes.number.isRequired
} : void 0;